import { render, staticRenderFns } from "./ItemNextMatches.vue?vue&type=template&id=5fb00323&scoped=true&"
import script from "./ItemNextMatches.vue?vue&type=script&lang=js&"
export * from "./ItemNextMatches.vue?vue&type=script&lang=js&"
import style0 from "./ItemNextMatches.vue?vue&type=style&index=0&id=5fb00323&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb00323",
  null
  
)

export default component.exports